import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import type { BaseAppDispatch, BaseRootState } from './types';

export const useAppDispatch = () => useDispatch<BaseAppDispatch>();
export const useAppSelector: TypedUseSelectorHook<BaseRootState> = useSelector;
